<template>
  <label
    :for="`tooth-${id}`"
    :class="[
      'tooth',
      active ? 'tooth--active' : '',
      toothOption ? 'tooth--used' : '',
      displayMode ? 'display' : ''
    ]"
  >
    <!-- @click.prevent.stop="active = !active" -->
    <div :class="['tooth--img', id < 17 ? 'pb-m' : 'pt-m']">
      <tooth-image :variant="img[0]" :variant-options="img[1]"></tooth-image>
    </div>
    <div class="tooth--num" v-text="method === 1 ? ADA : FDI"></div>
    <div class="tooth--options">
      <select
        class="tooth--options--select"
        @focus="toothFocus"
        @blur="active = false"
        :class="[toothOption !== 0 ? 'filled' : '']"
        :id="`tooth-${id}`"
        v-model="toothOption"
        :disabled="displayMode"
      >
        <option
          v-for="opt in toothOptions"
          :key="opt.value"
          :value="opt.value"
          v-text="opt.label"
        ></option>
      </select>
      <!-- <ul v-if="active" class="tooth--options--select">
        <li
          v-for="item in toothOptions"
          :key="item.value"
          v-text="item.label"
        ></li>
      </ul> -->
    </div>
  </label>
</template>
<script>
import ToothImage from "./ToothImage.vue";
export default {
  props: {
    value: {
      type: [String, Number, Object]
    },
    id: {
      type: [String, Number],
      required: true
    },
    /*
      Selected option for tooth
    */
    opt: {
      type: [String, Number],
      default: ""
    },
    ADA: {
      type: [String, Number]
    },
    FDI: [String, Number],
    img: {
      type: [Object, Array]
    },
    toothOptions: {
      type: Array,
      required: true
    },
    displayMode: {
      type: Boolean,
      default: false
    },
    method: {
      type: [String, Number],
      default: 1
    }
    // toothData: {
    //   type: Object,
    //   required: true
    // }
  },
  data() {
    return {
      active: false,
      used: false,
      toothOption: 0
    };
  },
  mounted() {
    if (this.opt) {
      this.toothOption = this.opt;
    }
  },
  watch: {
    opt() {
      if (this.opt) {
        this.toothOption = this.opt;
      }
    },
    toothOption() {
      this.$emit("tooth-updated", this.toothOption);
    }
    // active() {
    //   if (this.active) {
    //     let select = document.getElementById(`tooth-${this.id}`);
    //     select.size = 4;
    //     select.focus();
    //     console.log("select activtaed?, ", this.id);
    //   } else {
    //     console.log("select deactivate!", this.id);
    //     let select = document.getElementById(`tooth-${this.id}`);
    //     select.size = 0;
    //     // select.blur();
    //   }
    // }
  },
  components: {
    ToothImage
  },
  // props: ["label", "value"],
  methods: {
    updateVal() {
      this.$emit("input", this.$refs.field.value);
    },
    toothFocus(e) {
      console.log("toothFocus: ", e);
      this.active = true;
    }
  }
};
</script>

<style lang="stylus">
.tooth
  flex 1
  cursor pointer
  height 100%

  .tooth--img
    svg
      will-change transform
      transition transform 0.2s ease-out
      .a
        transition fill 0.2s ease-out
  &.display
    pointer-events none
  &--active
  &:hover
    &:not(.tooth--used):not(.display)
      .tooth--img svg
        transform translateY(-5%)
        &.y-flip
          transform scale(1, -1) translateY(-5%)
        &.x-flip
          transform scale(-1, 1) translateY(5%)
        &.x-flip.y-flip
          transform scale(-1, -1) translateY(-5%)
        .a
        &.tooth-5 .b
          fill #a8ddff !important

  &--used
    .tooth--img svg
      .a
      &.tooth-5 .b
        fill mix(blue_brand, blue_1) !important
  &--img
    img
    svg
      max-width 28px
      margin 0 auto
      display block
      +below(1200px)
        max-width 20px
  &--num
    text-align center
    background rgba(blue_brand, 0.2)
    color blue_brand
    line-height 30px
    font-weight 700
    font-size 14px
  &--options
    position relative
    margin 20px 0
    // background blue_brand
    &--select
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      background #fff
      border 1px solid gray_5
      padding 4px
      border-radius 2px
      line-height 1
      -webkit-appearance none
      text-align justify
      text-align-last center
      z-index 999999999
      transition border 0.2s ease-out, box-shadow 0.2s ease-out
      font-size responsive 11px 16px
      +below(1200px)
        font-size 11px
        padding 2px
        line-height 0.8
      &:focus
        border 1px solid blue_brand
        box-shadow 0 0 6px rgba(green_7, 0.5)
        outline none
      &.filled
        // border 1px solid blue_brand
        background blue_brand_8
        opacity 1
        color #fff
        outline none
        font-weight 600
      &.multiselect--active
        top 100%
        left 0
        transform translate(0,0)
        z-index 98
</style>
